import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    brandNoReturnedTitleContainer: {
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.grey700
    }
}));

const BrandNoReturnedTitle = (props) => {
    const { providerName, className } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        providerName && (
            <Typography
                className={classNames(classes.brandNoReturnedTitleContainer, className)}
            >
                {`Sorry, but we didn't receive a quote from ${providerName}`}

            </Typography>
        )
    );
};

BrandNoReturnedTitle.propTypes = {
    className: PropTypes.string,
    providerName: PropTypes.string.isRequired
};

export { BrandNoReturnedTitle };
